import styled from 'styled-components';

import { 
  PADDING_CONTENT_PAGE, PADDING_PAGE, 
  BACKGROUND_EMAIL_CONFIRM_INFO_SUCCESS, COLOR_EMAIL_CONFIRM_ICON_SUCCESS, 
  BACKGROUND_EMAIL_CONFIRM_INFO_ERROR, COLOR_EMAIL_CONFIRM_ICON_ERROR, 
  BACKGROUND_EMAIL_CONFIRM_INFO_WARNING, COLOR_EMAIL_CONFIRM_ICON_WARNING, 
  FONT_SIZE_EMAIL_CONFIRM_ICON 
} from '../../../globals';


export const StyledEmailConfirmContent = styled.div`
  padding: ${PADDING_PAGE}px;
  margin-top: 15px;

  .email-confirm-laoder {
    position: relative;
    min-height: 100px;
  }

  .email-confirm-table-success {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_EMAIL_CONFIRM_INFO_SUCCESS};
  }

  .email-confirm-icon-success {
    font-size: ${FONT_SIZE_EMAIL_CONFIRM_ICON}em;
    color: ${COLOR_EMAIL_CONFIRM_ICON_SUCCESS};
    padding: 10px;
  }

  .email-confirm-table-error {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_EMAIL_CONFIRM_INFO_ERROR};
  }

  .email-confirm-icon-error {
    font-size: ${FONT_SIZE_EMAIL_CONFIRM_ICON}em;
    color: ${COLOR_EMAIL_CONFIRM_ICON_ERROR};
    padding: 10px;
  }

  .email-confirm-table-warning {
    margin: 10px ${PADDING_CONTENT_PAGE}px 6px ${PADDING_CONTENT_PAGE}px;
    background-color: ${BACKGROUND_EMAIL_CONFIRM_INFO_WARNING};
  }

  .email-confirm-icon-warning {
    font-size: ${FONT_SIZE_EMAIL_CONFIRM_ICON}em;
    color: ${COLOR_EMAIL_CONFIRM_ICON_WARNING};
    padding: 10px;
  }

  .email-confirm-text {
    width: 100%;
  }

  .email-confirm-btn {
    margin-left: 6px;
    background: ${COLOR_EMAIL_CONFIRM_ICON_WARNING};
    color: white;
    border: none;
    padding: 0.5rem 0.75rem;
    font-weight: bold;
  }

  .email-confirm-btn:hover {
    background: #e66801;
  }
`;



// WEBPACK FOOTER //
// ./src/components/EmailConfirmContent/styles/StyledEmailConfirmContent.js